import { render, staticRenderFns } from "./ChooseNumber.vue?vue&type=template&id=34002865&scoped=true&"
import script from "./ChooseNumber.vue?vue&type=script&lang=js&"
export * from "./ChooseNumber.vue?vue&type=script&lang=js&"
import style0 from "./ChooseNumber.vue?vue&type=style&index=0&id=34002865&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34002865",
  null
  
)

export default component.exports